import i18n from 'i18next';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';

export const tenantColumns = {
  columns: {
    [SERVICE_PROVIDERS.SPIREON]: [
      {
        id: 'eld',
        numeric: false,
        disablePadding: false,
        label: i18n.t('ELD'),
        needSorting: false,
      },
    ],
    default: [],
  },
};

const cyntrxNauto = [
  {
    id: 'eldState',
    numeric: false,
    disablePadding: false,
    label: i18n.t('dashboard.tabs.driverStatus.eld'),
  },
  {
    id: 'currentStatus',
    disablePadding: false,
    label: i18n.t('Logs'),
  },
];

export const tenantColumnsOverride = {
  columns: {
    [SERVICE_PROVIDERS.RADIUS]: cyntrxNauto,
    [SERVICE_PROVIDERS.NAUTO]: cyntrxNauto,
    [SERVICE_PROVIDERS.BRIGHT_ORDER]: cyntrxNauto,
    [SERVICE_PROVIDERS.RISK_THEORY]: [],
    default: [
      {
        id: 'currentStatus',
        disablePadding: false,
        label: i18n.t('Logs'),
      },
    ],
  },
};
